import { Outlet } from "react-router-dom";
import ErrorBoundary from "../api/ErrorBoundary";
import SeoLoader from "../components/seo/SeoLoader";
import PaymentNavbar from "../components/navbar/navbarComponents/PaymentNavbar";

const PaymentLayout = () => (
  <div className="simple-layout">
    <ErrorBoundary>
      <SeoLoader />
      <PaymentNavbar />
      <Outlet />
    </ErrorBoundary>
  </div>
);

export default PaymentLayout;
